import script from "./DroppedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DroppedItem.vue?vue&type=script&setup=true&lang=js"

import "./DroppedItem.vue?vue&type=style&index=0&id=9ee61c78&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ee61c78"]])

export default __exports__